<ng-container *ngIf="eligible">
    <div class="apc-card" [class.apc-card--bare]="manageOnly">
        <div class="apc-header" *ngIf="!manageOnly">
            <div class="apc-title">{{ isSmsPurchase ? 'Pagar SMS con tarjeta' : 'Cobro automático con tarjeta' }}</div>
            <div class="apc-subtitle">{{ isSmsPurchase ? 'Paga tu paquete de SMS con la tarjeta guardada.' : 'Tu pago se procesará automáticamente al vencer el mes.' }}</div>
        </div>

        <div *ngIf="loading || (saving && !showCardForm)" class="apc-muted apc-loading">
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Preparando…
        </div>

        <!-- Tarjeta activa (no se muestra si fue rechazada: en ese caso manda el
             bloque de "rechazo definitivo" de más abajo, para no mostrar "Activo"
             y "rechazada" a la vez). -->
        <div *ngIf="!loading && hasActiveCard && !needsCardUpdate && !showCardForm" class="apc-active">
            <div class="apc-saved-card">
                <span class="apc-saved-card__icon" [class.apc-saved-card__icon--brand]="cardBrandIcon[0] === 'fab'">
                    <fa-icon [icon]="cardBrandIcon"></fa-icon>
                </span>
                <div class="apc-saved-card__info">
                    <div class="apc-saved-card__brand">{{ cardBrandLast4 }}</div>
                    <div class="apc-saved-card__exp" *ngIf="cardExpiry">Vence {{ cardExpiry }}</div>
                </div>
                <span class="apc-badge apc-badge--active">Activo</span>
            </div>
            <div class="apc-actions">
                <button type="button" class="apc-btn apc-btn--ghost" [disabled]="removing || paying" (click)="removeCard()">
                    {{ removing ? 'Eliminando…' : 'Eliminar tarjeta' }}
                </button>
                <button *ngIf="manageOnly" type="button" class="apc-btn apc-btn--ghost" [disabled]="removing || paying || saving" (click)="startAddCard()">Reemplazar tarjeta</button>
            </div>
        </div>

        <!-- Pagar ahora con la tarjeta guardada (on-session, resuelve 3DS). -->
        <div *ngIf="!loading && canPayNow && !showCardForm" class="apc-paynow">
            <button type="button" class="apc-btn apc-btn--primary apc-btn--block" [disabled]="paying || removing" (click)="payNow()">
                {{ paying ? 'Procesando pago…' : 'Pagar con mi tarjeta' }}
            </button>
            <div *ngIf="errorMessage" class="apc-error">{{ errorMessage }}</div>
        </div>

        <!-- Cobro sin confirmar (el procesador no respondió o el reintento no es
             seguro): no es un rechazo, así que no ofrecemos volver a intentarlo con
             la tarjeta. `canPayNow` ya oculta el botón de pago. -->
        <div *ngIf="!loading && chargeUnconfirmed && !showCardForm" class="apc-warning">
            {{ errorMessage }}
            <div class="apc-muted mt-2">Elige otro método de pago para completar esta factura.</div>
        </div>

        <!-- Requiere acción (p. ej. 3DS pendiente) -->
        <div *ngIf="!loading && autoCharge?.status === 'requires_action' && !showCardForm && !canPayNow && !chargeUnconfirmed" class="apc-warning">
            Tu último cobro requiere autenticación. Vuelve a guardar tu tarjeta para reactivar el cobro automático.
        </div>

        <!-- Rechazo definitivo: la tarjeta no puede usarse; hay que reemplazarla. -->
        <div *ngIf="!loading && needsCardUpdate && !showCardForm" class="apc-warning apc-warning--danger">
            Tu tarjeta fue rechazada y no puede usarse para el cobro automático. Reemplázala para continuar.
            <button type="button" class="apc-btn apc-btn--primary apc-btn--block mt-2" [disabled]="saving" (click)="startAddCard()">Reemplazar tarjeta</button>
        </div>

        <!-- Modo gestión sin tarjeta (p. ej. tras eliminar): permite agregar una.
             Se excluye `needsCardUpdate` para que un rechazo definitivo muestre solo
             el bloque de "Reemplazar tarjeta" (evita el doble CTA si el backend
             llegara a marcar la tarjeta como no activa). -->
        <div *ngIf="!loading && manageOnly && !hasActiveCard && !needsCardUpdate && !showCardForm && !saving && !errorMessage" class="apc-empty">
            <button type="button" class="apc-btn apc-btn--primary" (click)="startAddCard()">Agregar tarjeta</button>
        </div>

        <!-- Solo tras un error al preparar el formulario: permite reintentar. -->
        <div *ngIf="!loading && !hasActiveCard && !showCardForm && !saving && errorMessage" class="apc-empty apc-empty--error">
            <div class="apc-error">{{ errorMessage }}</div>
            <button type="button" class="apc-btn apc-btn--primary" (click)="startAddCard()">Reintentar</button>
        </div>

        <!-- Formulario del Payment Element -->
        <div *ngIf="showCardForm" class="apc-form">
            <div #paymentElementRef class="apc-payment-element"></div>
            <div *ngIf="errorMessage" class="apc-error">{{ errorMessage }}</div>
            <div class="apc-form-actions">
                <button type="button" class="apc-btn apc-btn--primary apc-btn--block" [disabled]="saving" (click)="confirmAddCard()">
                    {{ saving ? 'Guardando…' : manageOnly ? 'Guardar tarjeta' : 'Pagar y guardar' }}
                </button>
            </div>
            <div class="apc-secure">🔒 Pago seguro procesado por Stripe. Fina no almacena los datos de tu tarjeta.<br />Cancela en cualquier momento.</div>
        </div>
    </div>
</ng-container>
